import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import svg6 from "../../assets/svg/svg6.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const data = [
  { name: "Jan", Income: 4000, Expense: 2400, amt: 2400 },
  { name: "Feb", Income: 3000, Expense: 1398, amt: 2210 },
  { name: "March", Income: 2000, Expense: 9800, amt: 2290 },
  { name: "April", Income: 2780, Expense: 3908, amt: 2000 },
  { name: "May", Income: 1890, Expense: 4800, amt: 2181 },
  { name: "Jun", Income: 2390, Expense: 3800, amt: 2500 },
  { name: "July", Income: 3490, Expense: 4300, amt: 2100 },
];

const CustomizedLabel = ({ x, y, stroke, value }) => (
  <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
    {value}
  </text>
);

const CustomizedAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <text
      x={0}
      y={0}
      dy={16}
      textAnchor="end"
      fill="#666"
      transform="rotate(-35)"
    >
      {payload.value}
    </text>
  </g>
);

const NdovuGraph = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMoreDetails = () => {
    navigate("/ndovu-pay");
  };
  return (
    <div className="bg-white rounded-[10px] lg:p-10 p-2   w-full lg:h-[600px] h-auto">
      <div className=" flex items-center justify-between">
        <div className="product_request_title "> Income Statistics</div>
        <div
          className="flex items-center gap-x-3 cursor-pointer"
          onClick={handleMoreDetails}
        >
          More details <img src={svg6} alt="svg6" />
        </div>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={300}
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick />} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Expense"
            stroke="#EFC049"
            strokeWidth={2} 
            label={<CustomizedLabel />}
          />
          <Line type="monotone"  strokeWidth={2}  dataKey="Income" stroke="#49B5A6" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default NdovuGraph;
